"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Login = require("./Login.styles");
var _Login2 = require("./Login.labels");
var _LoginBtn = require("./partials/LoginBtn");
var _Purchase = require("./partials/Purchase");
var _hooks = require("../../hooks");
var _Title = require("../../UI/Title");
var _Modal = require("../../Layout/Modal");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _idmLogo = _interopRequireDefault(require("./resources/idmLogo.png"));
var _cetLogo_all = _interopRequireDefault(require("./resources/cetLogo_all.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Login = function Login(props) {
  var getLabel = (0, _hooks.useLabels)({
    labels: _Login2.labels
  });
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'popup' : _props$layout,
    _props$isWithCloseBut = props.isWithCloseButton,
    isWithCloseButton = _props$isWithCloseBut === void 0 ? true : _props$isWithCloseBut,
    onClose = props.onClose,
    _props$isWithPurchase = props.isWithPurchase,
    isWithPurchase = _props$isWithPurchase === void 0 ? false : _props$isWithPurchase,
    purchaseTitle = props.purchaseTitle,
    purchaseImage = props.purchaseImage,
    _props$purchaseButton = props.purchaseButtonLabel,
    purchaseButtonLabel = _props$purchaseButton === void 0 ? getLabel('purchase_default_btn_label') : _props$purchaseButton,
    purchaseButtonUrl = props.purchaseButtonUrl,
    purchaseImageAlt = props.purchaseImageAlt;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext.language;
  var styles = (0, _Login.useStyles)(props);
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isPopupOpen = _useState2[0],
    setIsPopupOpen = _useState2[1];
  var cetLogo = {
    he: _cetLogo_all.default,
    ar: _cetLogo_all.default,
    en: _cetLogo_all.default
  };
  var handleClose = function handleClose(event) {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(event);
    }
  };
  var handleLoginMoe = function handleLoginMoe() {
    window.cet.accessmanagement.loginMoe(window.location.href, false, language);
  };
  var handleLoginCet = function handleLoginCet() {
    window.cet.accessmanagement.loginCet(window.location.href, false, language);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Login'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      layout: layout,
      isOpen: isPopupOpen,
      onClose: handleClose,
      isWithCloseButton: isWithCloseButton,
      width: isWithPurchase ? 773 : 500,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-Login__content'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          className: styles['cc-Login__login-section'],
          children: [isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Login__title-purchase'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
              level: 3,
              color: "#fff",
              children: getLabel('purchase_login_subTitle')
            })
          }), !isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Login__title_container'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              children: getLabel('login_welcome_title')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              children: getLabel('login_welcome_subtitle')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Login__buttons'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginBtn.LoginBtn, {
                onClick: handleLoginMoe,
                imgSrc: _idmLogo.default,
                imgLabel: getLabel('login_idm_alt'),
                textLabel: getLabel('login_idm_btn')
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Login__idm_desc'],
                children: getLabel('login_idm_desc')
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginBtn.LoginBtn, {
              className: styles['cc-Login__cet_btn'],
              onClick: handleLoginCet,
              imgSrc: cetLogo[language],
              imgLabel: getLabel('login_cet_alt'),
              textLabel: getLabel('login_cet_btn')
            })]
          })]
        }), isWithPurchase && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Purchase.Purchase, {
          title: purchaseTitle,
          image: purchaseImage,
          buttonLabel: purchaseButtonLabel,
          buttonUrl: purchaseButtonUrl,
          imageAlt: purchaseImageAlt
        })]
      })
    })
  });
};
exports.Login = Login;